var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4841 16.886L18.4102 8.96002C17.3314 8.51109 16.0537 7.77356 14.8454 6.56523C13.6369 5.3567 12.8992 4.07883 12.4503 3L4.52416 10.9261C3.90566 11.5447 3.59635 11.854 3.33039 12.1949C3.01663 12.5972 2.74765 13.0324 2.52817 13.4929C2.34211 13.8833 2.20381 14.2982 1.92719 15.128L0.468509 19.5041C0.332383 19.9124 0.438662 20.3626 0.743053 20.6671C1.04744 20.9715 1.49768 21.0778 1.90605 20.9417L6.2821 19.4829C7.11194 19.2063 7.52689 19.0681 7.91728 18.882C8.37779 18.6625 8.81304 18.3935 9.21532 18.0798C9.55623 17.8138 9.86562 17.5045 10.4841 16.886Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1978 7.06614C21.8143 5.44966 21.8143 2.82883 20.1978 1.21236C18.5813 -0.40412 15.9603 -0.40412 14.3438 1.21236L13.4102 2.14605C13.423 2.18466 13.4362 2.2238 13.4499 2.26345C13.7922 3.24989 14.4379 4.54301 15.6527 5.75772C16.8674 6.97242 18.1605 7.61815 19.147 7.96038C19.1865 7.97407 19.2255 7.98727 19.2639 8L20.1978 7.06614Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3fedd6fc0ba478c912c8c0b0dcae6637.svg";
export { ForwardRef as ReactComponent };